var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"12"}},[_c('ProjectAssign'),_c('EmployeeProfile'),_c('EmployeeTiming'),_c('EventRegistration')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }